import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { CaseHistoryResponseDto } from '../dtos/case-history-response.dto';
import { EmployeeProfileResponseDto } from '../dtos/employee-profile-response.dto';

@Injectable({ providedIn: 'root' })
export class Employee360Api {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);

  public searchEmployees(term: string): Observable<EmployeeProfileResponseDto[]> {
    const sanitized = term.trim().substring(0, 100);
    let params = new HttpParams().set('isActive', 'true');
    if (sanitized.length >= 2) {
      params = params.set('search', sanitized);
    }
    return this._http.get<EmployeeProfileResponseDto[]>(
      `${this._config.versionedApiUrl}/employees`,
      { params },
    );
  }

  public getEmployee(userId: string): Observable<EmployeeProfileResponseDto> {
    return this._http.get<EmployeeProfileResponseDto>(
      `${this._config.versionedApiUrl}/employees/${userId}`,
    );
  }

  public getEmployeeCases(userId: string): Observable<CaseHistoryResponseDto[]> {
    return this._http.get<CaseHistoryResponseDto[]>(
      `${this._config.versionedApiUrl}/cases/by-requester/${userId}`,
    );
  }
}
